var React = require('react');

function OpenLinkIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".open-link-icon-svg{fill:#d0d0d0;}")),React.createElement("title",{"key":1},"openlink"),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":2},React.createElement("path",{"className":"open-link-icon-svg","d":"M11,0H5L7,2,4.23,4.85A1,1,0,0,0,5.65,6.27L8.46,3.46,11,6Z"})),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":3},React.createElement("path",{"className":"open-link-icon-svg","d":"M9,7V9H2V2H4V0H2A2,2,0,0,0,0,2V9a2,2,0,0,0,2,2H9a2,2,0,0,0,2-2V7Z"}))]);
}

OpenLinkIcon.defaultProps = {"viewBox":"0 0 11 11"};

module.exports = OpenLinkIcon;

OpenLinkIcon.default = OpenLinkIcon;
